module.exports = __webpack_public_path__ + "static/img_9412-d61f0c909c498342a53ed6f5699a447c.webp";